
<template>
  <h2 class="mb-4">{{ $t(title) }}</h2>
</template>

<script>
// @ is an alias to /src

export default {
  name: "SignUpTitle",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>